<template>
  <div class="detail-page">
    <header-back
      :title="title"
      @back="onClickBack"
    />
    <my-form
      v-if="!loading"
      :data="baseFormData"
    />
    <cube-loading
      v-else
      :size="24"
    />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'
import HeaderBack from '@/components/mobile/HeaderBack.vue'
import Form from './Form'
import eventBus from '@/lib/eventBus'

export default {
  components: {
    HeaderBack,
    MyForm: Form
  },
  data () {
    return {
      type: 'add', // add detail edit
      title: this.$t('message["622"]') // 录入信息，code
    }
  },
  computed: {
    ...mapState('inquery/detailData', ['isDeal']),
    ...mapState('inquery/addConfigData', [
      'loading',
      'configData',
      'baseinfo'
    ]),
    ...mapGetters('inquery/addConfigData', [
      'formData'
    ]),
    fromInfoOptions () {
      const { from_info: fromInfo = {} } = this.formData || {}
      const { child = [] } = fromInfo

      let arr = child.map(item => {
        return {
          name: item.fieldname,
          id: item.fieldkey
        }
      })
      return arr
    },
    baseFormData () {
      let data = this.formData

      const { info: inquiryInfo = {} } = this.formData || {}
      const { child: infoChild = {} } = inquiryInfo

      if (infoChild && infoChild[0]) {
        let { fieldvalue: trueName } = infoChild[0]
        if (!trueName) {
          trueName = this.baseinfo && this.baseinfo.truename
          data.info.child[0].fieldvalue = trueName
        }
      }

      /* for (let k in data) {
        data[k].show = true
        if (k === 'deal_info') {
          data[k].show = this.isDeal
        }
      } */

      return data
    },
    formHistoryId () {
      return this.$route.query.form_history_id
    }
  },
  async created () {
    await this.fetchConfigDetail()
    // 清空关联人员列表
    this.SET_RELATE_LIST_DATA([])

    eventBus.$on('fetchAddConfig', this.fetchConfigDetail)
  },
  methods: {
    ...mapActions('inquery/addConfigData', ['fetchDetail']),
    ...mapMutations('inquery/relateData', ['SET_RELATE_LIST_DATA']),
    async fetchConfigDetail () {
      let params = {}
      if (this.formHistoryId) {
        params.form_history_id = this.formHistoryId
      }
      const chain = await this.fetchDetail()
      chain
        .params(params)
        .onSuccess(res => {
          let { projectname = '', comname = '' } = this.$store.state.baseinfo || {}
          projectname && (projectname = ' - ' + projectname)
          comname && (comname = ' - ' + comname)
          let title = this.$t('message["622"]') + projectname + comname
          document.title = title
        })
        .fetch()
    },
    onClickBack () {
      this.$router.push({
        name: 'ProjectIndex'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-page {
  ::-webkit-input-placeholder {
    color: #999;
    font-size: 16px;
  }
}
</style>
